import React, { useState, useEffect, useContext } from 'react';
import { SingleDatePicker } from 'react-dates';

import Select from 'react-select';

import { ask__ } from './../../shared/utils/i18n.js';
import { getSpecialists, getServices, getTimeslots, getAvailableDays, getLanguages } from './../../shared/utils/api.js';
import Icon from '../Icon/Icon';
import Loader from '../Loader/Loader';
import Timeslot from '../Timeslot/Timeslot';
import Dropdown from '../Dropdown/Dropdown';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalIsBlockedContext } from './../../shared/context/GlobalIsBlocked.js';
import moment from 'moment/min/moment-with-locales';
import './Booking.scss';
import 'react-dates/lib/css/_datepicker.css';

import { getLang, getAppQueryParam } from './../../shared/utils/environment.js';

import 'react-dates/initialize';

const TYPES_FOR_PHONE = ['phone', 'puhelinkartoitus', 'maksuton-puhelinkartoitus'];

export default function Booking() {

  // set date locale
  moment.locale(getLang());

  // get query arg "type"
  const type = getAppQueryParam('type');

  const overridePhoneSelected = type ? TYPES_FOR_PHONE.includes(type) : false;

  /**
   * Init state
   */
  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalIsBlocked} = useContext(GlobalIsBlockedContext);

  const [isInitLoading,       setIsInitLoading]  = useState(true);
  const [isLoadingTimes,      setIsLoadingTimes]  = useState(false);
  const [isTabNextTimes,      setIsTabNextTimes]  = useState(true);
  const [getTimes,            setTimes]           = useState([]);

  const [availableServices,    setAvailableServices] = useState([]);
  const [selectedService,      setSelectedService]   = useState(null);
  const [phoneConstultationService, setPhoneConstultationService] = useState(null);
  const [isPhoneConsultationServiceSelected, setIsPhoneConsultationServiceSelected] = useState(false);
  const [isLoadingService,     setIsLoadingService]  = useState(false);
  const [isServicesInitted,    setIsServicesInitted] = useState(false);

  const [availableResources,  setAvailableResources] = useState([]);
  const [selectedResource,    setSelectedResource]   = useState(null);
  const [isLoadingResource,   setIsLoadingResource]  = useState(false);
  const [resourceFromURL,     setResourceFromURL]    = useState(false);
  const [specialistFromUrl,   setSpecialistFromUrl]  = useState(false);

  const [timeTypeReceptionSelected, setTimeTypeReceptionSelected] = useState(overridePhoneSelected ? false : true);
  const [timeTypePhoneSelected, setTimeTypePhoneSelected] = useState(true);
  const [timeTypeVideoSelected, setTimeTypeVideoSelected] = useState(overridePhoneSelected ? false : true);


  const [availableLanguages,  setAvailableLanguages] = useState([]);
  const [selectedLanguage,    setSelectedLanguage]   = useState(null);
  const [isLoadingLanguage,   setIsLoadingLanguage]  = useState(false);

  /**
   * Why thereis getTimeTrigger instead of using calendarDate changes?
   *
   * calendarDate is mainly for calendar component and it needs to be moment() object all the time
   * and the main issue is that when choosing a specialist you don't know the right date so by
   * only using calendarDate you will get weird double renders and slower loading times. The
   * getTimeTrigger is only "cache invalidator" that triggers fetching times.
   */
  const [calendarDate,           setCalendarDate]           = useState(moment());
  const [getTimesTrigger,         setGetTimesTrigger]         = useState(null);

  const [calendarAvailableDays,  setcalendarAvailableDays]  = useState([]);
  const [calendarFocused,        setcalendarFocused]        = useState(true);
  const [calendarIsLoading,      setCalendarIsLoading]      = useState(false);
  const [caledarDaySize,         setCaledarDaySize]         = useState(48);

  const [calendarNavPrevDate, setCalendarNavPrevDate]            = useState(false);
  const [calendarNavNextDate, setCalendarNavNextDate]            = useState(false);

  const [activeSpecialists, setActiveSpecialists] = useState([]);

  /**
   * Setup resources dropdown
   */
  const setupResources = async (args = {}) => {
    setIsLoadingResource(true);
    const specialistData = await getSpecialists({
      'service' : (typeof args.service !== 'undefined' && args.service !== null && typeof args.service.value !== 'undefined') ? parseInt(args.service.value) : null,
      'language' : (typeof args.language !== 'undefined' && args.language !== null && typeof args.language.value !== 'undefined') ? parseInt(args.language.value) : null,
      'is_phone_consultation' : (typeof args.service !== 'undefined' && args.service !== null && typeof args.service.value !== 'undefined') ? args?.service?.is_phone_consultation : false,
    });

    if (typeof specialistData !== 'undefined' && specialistData.length) {
      let parameterSpecialist = false;
      let specialistOpts = [];
      for (let i = 0; i < specialistData.length; i++) {

        const specialist = {
          'label' : specialistData[i].name_full,
          'value' : specialistData[i].pid,
          'notice' : specialistData[i].notice,
        };

        if (resourceFromURL && resourceFromURL == specialistData[i].pid) {
          parameterSpecialist = specialist;
        }
        specialistOpts.push(specialist);

      }
      setAvailableResources(specialistOpts);
      setIsLoadingResource(false);

      // pre-select by url parameter
      if (resourceFromURL && parameterSpecialist && !isLoadingResource) {
        setSelectedResource(parameterSpecialist);
        setResourceFromURL(false);
      }

    } else {
      setIsInitLoading(false);
    }
  };

  /**
   * Setup languages dropdown
   */
  const setupLanguages = async (service = null) => {
    setIsLoadingLanguage(true);
    let languageData = await getLanguages({
      'service' : (service !== null && typeof service.value !== 'undefined') ? parseInt(service.value) : null,
    });
    if (typeof languageData !== 'undefined' && Object.keys(languageData).length) {
      languageData = Object.values(languageData);
      let languageOpts = [];
      for (let i = 0; i < languageData.length; i++) {
        languageOpts.push({
          'label' : languageData[i].language_name,
          'value' : languageData[i].language_id,
        });
      }
      setAvailableLanguages(languageOpts);
    } else {
      setIsInitLoading(false);
    }
    setIsLoadingLanguage(false);
   };

  /**
   * Setup services dropdown
   */
  const setupServices = async (lang = null) => {
    setIsLoadingService(true);
    let serviceData = await getServices({
      'language' : (lang !== null && typeof lang.value !== 'undefined') ? parseInt(lang.value) : null,
    });
    let phoneConstultationServiceValue = null;
    if (typeof serviceData !== 'undefined' && Object.keys(serviceData).length) {
      serviceData = Object.values(serviceData);
      let serviceOpts = [];
      for (let i = 0; i < serviceData.length; i++) {
        serviceOpts.push({
          'label' : serviceData[i].service_name,
          'value' : serviceData[i].service_id,
          'is_child' : serviceData[i].service_is_child,
          'notice' : serviceData[i].service_notice,
          'is_phone_consultation' : serviceData[i].service_is_phone_consultation,
        });
        if (serviceData[i].service_is_phone_consultation) {
          phoneConstultationServiceValue = serviceOpts[serviceOpts.length - 1];
        }
        if (serviceData[i].service_children.length) {
          for (let j = 0; j < serviceData[i].service_children.length; j++) {
            serviceOpts.push({
              'label' : serviceData[i].service_children[j].service_name,
              'value' : serviceData[i].service_children[j].service_id,
              'is_child' : serviceData[i].service_children[j].service_is_child,
              'notice' : serviceData[i].service_children[j].service_notice,
              'is_phone_consultation' : serviceData[i].service_children[j].service_is_phone_consultation,
            });
            if (serviceData[i].service_children[j].service_is_phone_consultation) {
              phoneConstultationServiceValue = serviceOpts[serviceOpts.length - 1];
            }
          }
        }
      }
      if (phoneConstultationServiceValue) {
        setPhoneConstultationService(phoneConstultationServiceValue);
      }
      setAvailableServices(serviceOpts);
      if ( overridePhoneSelected && phoneConstultationServiceValue && ! isServicesInitted) {
        setSelectedService(phoneConstultationServiceValue);
      }
      setIsServicesInitted(true);
    } else {
      setIsInitLoading(false);
    }
    setIsLoadingService(false);
  };

  /**
   * Init
   */
  useEffect(() => {
    if (availableLanguages.length && availableServices.length && availableResources.length) {
      setIsInitLoading(false);
    }
  }, [availableLanguages, availableServices, availableResources]);

  /**
   * Parameter values
   */
  useEffect(() => {
    if (!isInitLoading) {
      const specialistFromUrlRaw = getAppQueryParam('specialist');
      if (specialistFromUrlRaw !== null && availableResources.length) {
        for (let resource of availableResources) {
          if (resource.value == specialistFromUrlRaw) {
            setSpecialistFromUrl(true);
            setSelectedResource(resource);
          }
        }
      }
    }
  }, [isInitLoading]);

  /**
   * Services
   */

  // update available services
  useEffect(() => {setupServices(selectedLanguage)}, [selectedLanguage]);

  // update available languages
  useEffect(() => {setupLanguages(selectedService)}, [selectedService]);

  // update available resources
  useEffect(() => {
    if (selectedService && phoneConstultationService && phoneConstultationService.value === selectedService.value) {
      setIsPhoneConsultationServiceSelected(true);
    } else {
      setIsPhoneConsultationServiceSelected(false);
    }
    setupResources({'service': selectedService, 'language': selectedLanguage});
  }, [selectedService, selectedLanguage]);

  /**
   * Calendar
   */

  // update calendar
  useEffect(() => {

    (async() => {

      setCalendarIsLoading(true);

      if (activeSpecialists.length) {
        try {

          const availableDaysArgs = {
            'ids' : activeSpecialists,
            'is_single_specialist': selectedResource ? true : false,
          };

          // const selectedTypes = [];

          // if (timeTypeReceptionSelected) {
          //   selectedTypes.push('reception');
          // }
          // if (timeTypePhoneSelected) {
          //   selectedTypes.push('phone');
          // }
          // if (timeTypeVideoSelected) {
          //   selectedTypes.push('video');
          // }

          // if (selectedTypes.length) {
          //   availableDaysArgs.type = selectedTypes.join('|');
          // }

          if (selectedService && selectedService.is_phone_consultation) {
            availableDaysArgs.type = 'phone';
          }

          const days = await getAvailableDays(availableDaysArgs);

          setcalendarAvailableDays(days);

          // go to first available day
          if (days.length) {
            setCalendarDate(moment(days[0]));
            setGetTimesTrigger(Date.now());

            // move calendar
            setcalendarFocused(false);
            setTimeout(() => {
              setcalendarFocused(true);
            }, 250)

          } else {
            setGetTimesTrigger(Date.now());
          }

        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'CAD101'
          });
        }

      }



      // @todo available days
      setCalendarIsLoading(false);
    })();

  }, [activeSpecialists, timeTypePhoneSelected, timeTypeReceptionSelected, timeTypeVideoSelected]);

  // update calendar nav
  useEffect(() => {
    if (calendarAvailableDays.length) {
      const strDate = calendarDate.format('YYYY-MM-DD');
      const currentIndex = calendarAvailableDays.indexOf(strDate);
      if (currentIndex >= 0) {
        const nextIndex = currentIndex + 1;
        const prevIndex = currentIndex - 1;
        if (calendarAvailableDays[nextIndex] !== undefined) {
          setCalendarNavNextDate(moment(calendarAvailableDays[nextIndex]));
        } else {
          setCalendarNavNextDate(null);
        }
        if (calendarAvailableDays[prevIndex] !== undefined) {
          setCalendarNavPrevDate(moment(calendarAvailableDays[prevIndex]));
        } else {
          setCalendarNavPrevDate(null);
        }
      } else {
        setCalendarNavNextDate(null);
        setCalendarNavPrevDate(null);
      }
    } else {
      setCalendarNavNextDate(null);
      setCalendarNavPrevDate(null);
    }
  }, [calendarDate, calendarAvailableDays]);

  /**
   * Active specialists (for timeslots)
   */
  useEffect(() => {

    if (selectedResource !== null) {
      setActiveSpecialists([selectedResource.value]);
      setIsLoadingTimes(true);
    } else if ((selectedService && availableResources.length) || (selectedLanguage && availableLanguages.length)) {
      let ids = [];
      for (let i = 0; i < availableResources.length; i++) {
        ids.push(availableResources[i].value)
      }
      setActiveSpecialists(ids);
      setIsLoadingTimes(true);
    } else {
      setActiveSpecialists([]);
      setIsLoadingTimes(false);
    }

  }, [selectedResource, availableResources, selectedLanguage]);

  // get times
  useEffect(() => {

    (async () => {

      if (calendarDate && activeSpecialists.length) {

        setIsLoadingTimes(true);

        try {

          const timeSlotsArgs = {
            'ids' : activeSpecialists,
            'on' : calendarDate.format('YYYY-MM-DD'),
            'is_single_specialist': selectedResource ? true : false,
          };

          // const selectedTypes = [];

          // if (timeTypeReceptionSelected) {
          //   selectedTypes.push('reception');
          // }
          // if (timeTypePhoneSelected) {
          //   selectedTypes.push('phone');
          // }
          // if (timeTypeVideoSelected) {
          //   selectedTypes.push('video');
          // }

          // if (selectedTypes.length) {
          //   timeSlotsArgs.type = selectedTypes.join('|');
          // }

          if (selectedService && selectedService.is_phone_consultation) {
            timeSlotsArgs.type = 'phone';
          }

          const timeslots = await getTimeslots(timeSlotsArgs);

          setTimes(timeslots);

        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'CAT102'
          });
        }

        setIsLoadingTimes(false);


      }
    })();

  }, [getTimesTrigger]);

    /**
     * Responsive
     */
    useEffect(() => {

      if (window.innerWidth > 1160) {
        setCaledarDaySize(48);
      } else {
        setCaledarDaySize(42);
      }

    }, [window.innerWidth]);

  return (<>
    {getGlobalIsBlocked ? <>
      <div className="booking booking-blocked">
        <div className="booking-blocked__content" dangerouslySetInnerHTML={{__html: (window.ortonWebsiteData.i18n.blocked || '')}}></div>
      </div>
    </> : <>
      <div className={!isLoadingTimes && !isInitLoading ? 'booking' : 'booking booking--loading-times' }>

        <div className="booking__init booking__init--mobile">
          <div className="booking__header">
            <div className="booking__header__content">
              <h2 className="booking__title">{ ask__('Booking: Instructions title') }</h2>
            </div>
          </div>

          <div className="booking__instructions">
            <p>{ ask__('Booking: Instructions text') }</p>
          </div>
        </div>

        <div className="booking__controls">

          {/*<span className="booking__controls__label booking__controls__label--type">{ ask__('Booking: Choose type') }</span>*/}
          {/* <div className="booking__types">
            <div className="booking__type">
              <label htmlFor='tt-reception'>
                <input
                  type="checkbox"
                  id="tt-reception"
                  name="reception"
                  checked={timeTypeReceptionSelected}
                  onChange={() => {setTimeTypeReceptionSelected(!timeTypeReceptionSelected);}}
                />
                <span>{ask__('Booking: Reception')}</span>
              </label>
            </div>
            <div className="booking__type">
              <label htmlFor='tt-video'>
                <input
                  type="checkbox"
                  id="tt-video"
                  name="video"
                  checked={timeTypeVideoSelected}
                  onChange={() => {setTimeTypeVideoSelected(!timeTypeVideoSelected);}}
                />
                <span>{ask__('Navigation: Chat')}</span>
              </label>
            </div>
            <div className="booking__type">
              <label htmlFor='tt-phone'>
                <input
                  type="checkbox"
                  id="tt-phone"
                  name="phone"
                  checked={timeTypePhoneSelected}
                  onChange={() => {setTimeTypePhoneSelected(!timeTypePhoneSelected);}}
                />
                <span>{ask__('Booking: Phone')}</span>
                </label>
            </div>
          </div> */}

          {/*<span className="booking__controls__label booking__controls__label--specialist">{ask__('Booking: Filter specialists') }</span>*/}

          {/* {phoneConstultationService && ! isInitLoading && ! specialistFromUrl ? <>
            <button
              className="booking-button-phone"
              data-is-selected={selectedService && selectedService.value && phoneConstultationService.value === selectedService.value}
              onClick={e => {
                e.preventDefault();
                if (selectedService !== phoneConstultationService) {
                  setSelectedLanguage(null);
                  setSelectedResource(null);
                  setSelectedService(phoneConstultationService);
                  setIsLoadingTimes(true);
                } else {
                  setSelectedService(null);
                  setIsLoadingTimes(false);
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill="currentColor" d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/></svg>
              <span className="booking-button-phone__label">{ask__('Booking: Phone')}</span>
              { new Date().getFullYear() === 2025 ? <span className="booking-button-phone__new">{ask__('Booking: New')}</span> : ''}
            </button>
            { isPhoneConsultationServiceSelected ? <>
              <div className="booking-button-phone-back">
                <button
                  onClick={e => {
                    e.preventDefault();
                    setSelectedService(null);
                    setIsLoadingTimes(false);
                  }}
                >
                  <Icon name="chevron" orientation="left" />
                  <span>{ask__('Booking: Back to booking seach')}</span>
                </button>
              </div>
            </> : ''}
          </> : ''} */}

          { isPhoneConsultationServiceSelected ? '' : <>
            <Dropdown
              label={ask__('Booking: Service')}
              value={selectedService}
              options={availableServices}
              isLoading={isLoadingService}
              onNewValue={option => {
                setSelectedService(option);
                if (option) {
                  setIsLoadingTimes(true);
                }
              }}
              formatOptionLabel={option => {
                return option.is_child ? <span className="filter__option__child">{option.label}</span> : <span className="filter__option__parent">{option.label}</span>
              }}
            />
            <Dropdown
              label={ask__('Booking: Staff')}
              value={selectedResource}
              options={availableResources}
              isLoading={isLoadingResource}
              onNewValue={option => {
                setSelectedResource(option)
              }}
            />

            <Dropdown
              label={ask__('Booking: Language')}
              value={selectedLanguage}
              options={availableLanguages}
              isLoading={isLoadingLanguage}
              onNewValue={option => {
                setSelectedLanguage(option);
              }}
            />
          </>}

          {activeSpecialists.length ? <>
            <div className="booking__tabs">
              <button
                className={isTabNextTimes ? 'booking__tab booking__tab--active' : 'booking__tab'}
                onClick={e => {
                  e.preventDefault();
                  setIsTabNextTimes(true);
                }}
              >
                { ask__('Booking: Next times') }
              </button>
              <button
                className={!isTabNextTimes ? 'booking__tab booking__tab--active' : 'booking__tab'}
                onClick={e => {
                  e.preventDefault();
                  setIsTabNextTimes(false);
                }}
              >
                { ask__('Booking: Calendar') }
              </button>
            </div>
          </> : ''}

          {/* <span className="booking__controls__label booking__controls__label--datepicker">{ ask__('Booking: Choose date') }</span> */}

          <div className={!isTabNextTimes ? 'datepicker datepicker--active' : 'datepicker'}>

            <SingleDatePicker
              date={calendarDate}
              onDateChange={date => {
                setCalendarDate(date);
                setIsTabNextTimes(true);
                if (!isLoadingResource && !isLoadingService && !isLoadingLanguage && activeSpecialists.length) {
                  setGetTimesTrigger(Date.now());
                }
              }}
              focused={calendarFocused}
              navPrev={<Icon name="chevron" orientation="left" />}
              navNext={<Icon name="chevron" orientation="right" />}
              onFocusChange={() => true}
              numberOfMonths={1}
              firstDayOfWeek={1}
              hideKeyboardShortcutsPanel={true}
              enableOutsideDays={false}
              keepOpenOnDateSelect={true}
              initialVisibleMonth={() => calendarDate}
              isDayBlocked={day => !calendarAvailableDays.includes(day.format('YYYY-MM-DD'))}
              daySize={caledarDaySize}
              disabled={calendarIsLoading}
              id="orton_booking"
            />

            {calendarFocused ? <>
              <div className="booking__legends">
                <span className="booking__legends__item booking__legends__item--free">{ask__('Booking: Available times')}</span>
                <span className="booking__legends__item booking__legends__item--chosen">{ask__('Booking: Chosen day')}</span>
              </div>
            </> : ''}
          </div>

        </div>

        <div className={isTabNextTimes ? 'booking__content booking__content--active' : 'booking__content'}>

          {activeSpecialists.length ? <>
            <div className="booking__header">
              <div className="booking__header__content">
                <h2 className="booking__title">{ ask__('Booking: Title') }</h2>
                <h3 className="booking__subtitle">{calendarDate.format('dddd D.M.YYYY')}</h3>
              </div>
              <div className="booking__header__controls">
                {/* <div className="choose-date">
                  <button className="choose-date__button">{ask__('Booking: Choose day')}</button>
                </div> */}
                <div className="calendar-nav">
                  <button
                    disabled={calendarNavPrevDate === null ? true : false}
                    onClick={e => {
                      // @todo moving past months
                      e.preventDefault();
                      setCalendarDate(calendarNavPrevDate);
                      setGetTimesTrigger(Date.now());

                    }}
                    className="calendar-nav__button calendar-nav__button--prev"
                  >
                    <Icon orientation="left" name="chevron" />
                  </button>
                  <button
                    disabled={calendarNavNextDate === null ? true : false}
                    onClick={e => {
                      e.preventDefault();
                      setCalendarDate(calendarNavNextDate);
                      setGetTimesTrigger(Date.now());
                    }}
                    className="calendar-nav__button calendar-nav__button--next"
                  >
                    <Icon orientation="right" name="chevron" />
                  </button>
                </div>
              </div>

            </div>

            {selectedResource && selectedResource.notice ? <>
            <div className="booking__notice booking__notice--resource">
              <div className="booking__notice__icon"><Icon name="alert-outline" /></div>
              <div className="booking__notice__content" dangerouslySetInnerHTML={{__html: (selectedResource.notice || '')}}></div>
            </div>
            </> :''}
            {selectedService && selectedService.notice ? <>
            <div className="booking__notice booking__notice--service">
              <div className="booking__notice__icon"><Icon name="alert-outline" /></div>
              <div className="booking__notice__content" dangerouslySetInnerHTML={{__html: (selectedService.notice || '')}}></div>
            </div>
            </> :''}

            <div className="available">

              {isLoadingTimes ? <>
                <Loader />
              </> : <>
                {getTimes.length ? <>

                  <div className="timeslots">

                  {getTimes.map((t, i) => {
                    return (
                      <Timeslot
                        key={i}
                        type="booking"
                        timeStart={t.time_start}
                        timeDay={t.time_day}
                        timeHour={t.time_hour}
                        timeType={t.type}
                        duration={t.duration}
                        unit={t.unit}
                        resourcePath={t.resource_path}
                        isVideoReception={t.is_video_reception}
                        isPhoneReception={t.is_phone_reception}
                        locationName={t.unit_name}
                        locationAddress={t.unit_address}
                        specialistUrl={t.specialist.has_meta ? t.specialist.specialist_url : ''}
                        name={t.specialist.has_meta ? t.specialist.name : ''}
                        title={t.specialist.has_meta ? t.specialist.title : ''}
                        legal={t.specialist.has_meta ? t.specialist.legal : ''}
                        image={t.specialist.has_meta ? t.specialist.img_url : ''}
                        notice={t.specialist.has_meta ? t.specialist.notice : ''}
                      />
                    )
                  })}

                  </div>

                </> : <>
                  <div className="booking__empty">
                    <p>{ ask__('Booking: No times available') }</p>
                  </div>

                </>}
              </>}
            </div>

          </> : <>

            <div className="booking__init booking__init--desktop">
              {isInitLoading ? <>
                <Loader />
              </> : <>
                <div className="booking__header">
                  <div className="booking__header__content">
                    <h2 className="booking__title">{ ask__('Booking: Instructions title') }</h2>
                  </div>
                </div>
                <div className="booking__instructions">
                  <p>{ ask__('Booking: Instructions text') }</p>
                </div>
              </>}


            </div>

          </>}


        </div>

        {!activeSpecialists.length ? <div className="booking__filler booking__filler--big"></div> : <div className="booking__filler booking__filler--small"></div>}


      </div>
    </>}
  </>
  )

}
